export enum LocaleEnum {
  ENGLISH = 'en',
  SPANISH = 'es',
}
